import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
  signal,
} from '@angular/core';
import { Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-preventive-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-preventive-dialog.component.html',
  styleUrl: './confirm-invoice-dialog.component.scss',
})
export class ConfirmPreventiveDialogComponent {
  confirmed = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmPreventiveDialogComponent>,
  ) {
    /* Stesse classi del dialog dei Termini e Condizioni, di cui questo
       condivide il foglio di stile: la superficie vive nell'overlay CDK ed e'
       un ANTENATO del componente, quindi contorno e fascia panna arrivano
       dalle regole globali di .izy-info-dialog-panel.
       .izy-auto-height-dialog-panel toglie l'altezza fissa passata dai
       chiamanti alla MatDialogConfig: qui il contenuto e' una riga sola. */
    this.dialogRef.addPanelClass([
      'izy-info-dialog-panel',
      'izy-auto-height-dialog-panel',
    ]);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
